import { SITE, waLink } from "@/lib/site";
import { Phone, MessageCircle } from "lucide-react";

export default function MobileBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t border-ink bg-paper"
      data-testid="mobile-bar"
    >
      <a
        href={`tel:${SITE.phoneTel}`}
        className="flex items-center justify-center gap-2 py-4 border-r border-ink"
        data-testid="mobilebar-call"
      >
        <Phone size={16} /> Call
      </a>
      <a
        href={waLink}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center gap-2 py-4"
        data-testid="mobilebar-wa"
      >
        <MessageCircle size={16} /> WhatsApp
      </a>
    </div>
  );
}
